<template>
  <div class="medal-page-wrap height-100'">
    <div class="home-page game-outer">
      <div>
        <div class="medal-details-wrap" :class="showThanks? 'display-flex': ''">
          <div class="medal-details">
            <div class="status-image">
              <img :src="gameContent.badge" alt="medal">
            </div>
            <h4 class="medal-title">{{ pageContent.title }}</h4>
            <p class="sub-text" v-if="!showThanks" v-html="pageContent.description">
            </p>
            <p class="sub-text thanks" v-else>{{ pageContent.sub_title }}</p>
            <div class="medal-basic-form animate-slidein" v-if="!showThanks">
              <div class="medal-block">
                <div class="form-group user">
                  <input  type="name" v-model="medalInfo.name" id="name">
                  <label for="name">Fullt nafn:</label>
                </div>
                <div class="detail-block-outer">
                  <div class="form-group address">
                    <input type="address" id="address" v-model="medalInfo.address">
                    <label for="address">Heimilisfang:</label>
                  </div>
                  <div class="form-group post-num">
                    <input class="integerInputPostNumber" maxlength="3" type="text" id="post-num" v-model="medalInfo.post_number">
                    <label for="post-num">Póstnúmer:</label>
                  </div>
                </div>
              </div>
              <!-- Temporarily hiding the medal subscribe button -->
              <!-- <div class="facebook">
                <button class="button medal-send" v-on:click="subscribeMedal()">{{ pageContent.cta_links[0].text }}</button>
                <button class="button no-thanx" @click="$router.replace('/fb/share/')">{{ pageContent.cta_links[1].text }}</button>
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/* global gtag */
/* eslint no-undef: "error" */
import { MedalInfo, IcelandicPinCodes } from '@/shared/dataModels'
import API from '@/shared/api'
export default {
  name: 'MedalPage',
  data () {
    return {
      facebook: null,
      medalInfo: new MedalInfo(),
      clubImage: null,
      userTotalPoints: null,
      medalData: {
        'status': false
      },
      shown: false,
      fullName: null,
      dataReady: false,
      userInfo: null,
      mandatoryFields: ['address', 'post_number'],
      missedFields: [],
      icelandicPinCodes: IcelandicPinCodes,
      showMedal: false,
      showThanks: false,
      gameContent: {},
      pageContent: {},
    }
  },
  created () {
    if (this.$data.globalData.user && this.$data.globalData.user.user_club) {
      this.clubImage = this.$data.globalData.user.user_club.image_url
      if (this.$data.globalData.user.user_total_points) {
        this.userTotalPoints = this.$data.globalData.user.user_total_points
      }
    }
    if (this.$data.globalData.user) {
      this.userInfo = this.$data.globalData.user
    }
    if (this.$data.globalData.user) {
      this.fullName = this.$data.globalData.user.name
      if (this.fullName) {
        this.medalInfo.name = this.fullName
      }
    }
    if (this.$data.globalData.gameContent) {
      this.gameContent = this.$data.globalData.gameContent
    }
    if (this.$data.globalData.pageContent) {
      this.pageContent = this.$data.globalData.pageContent['medal-form']
    }
    this.dataReady = true
  },
  methods: {
    subscribeMedal () {
      this.missedFields = this.isValidData()
      if (this.missedFields.length === 0) {
        if (this.medalInfo['name'].split(' ').length === 1) {
          const h = this.$createElement
          this.$notify({
            customClass: 'error-name-msg',
            message: h('i', { style: 'color: #f7653a' }, 'Vinsamlegast sláðu inn fullt nafn.'),
            position: 'top right',
          })
          return
        }
        let verifiedNumber = false
        for (let pencil = 0; pencil < this.icelandicPinCodes.length; pencil++) {
          if (this.icelandicPinCodes[pencil] == this.medalInfo.post_number) {
            verifiedNumber = true
          }
        }
        if(verifiedNumber) {
          API.meInstance.post('/subscribe/medal/r2020', this.medalInfo).then((res) => {
            this.medalData.status = res.data.status
            if (res) {
              if (res.data.status) {
                gtag('config', this.$data.globalData.google_track_id, {
                  'page_title' : 'sendurpeningur',
                  'page_path': '/quiz/?sendurpeningur'
                })
                this.showThanks = true
                const h = this.$createElement
                this.$notify({
                  customClass: 'success-medal',
                  message: h('i', { style: 'color: #011627' }, 'Skráning tókst'),
                  duration: 2000,
                  position: 'top right',
                })
                setTimeout(() => {
                  this.$router.replace('/fb/share/')
                }, 2000)
              } else {
                const h = this.$createElement
                this.$notify({
                  // title: 'Villa',
                  customClass: 'error-msg',
                  message: h('i', { style: 'color: #f7653a' }, res.data.error)
                })
              }
            }
          }).catch((error) => {
            const h = this.$createElement
            this.$notify({
              // title: 'Villa',
              customClass: 'error-msg',
              message: h('i', { style: 'color: #f7653a' }, 'Villa, ekki hægt að klára beiðni.')
            })
          })
        } else {
         const h = this.$createElement
          this.$notify({
            // title: 'Villa',
            customClass: 'error-msg',
            message: h('i', { style: 'color: #f7653a' }, 'Ekki var slegið inn gilt póstnúmer')
          })
        }
      } else {
        const h = this.$createElement
        let req = []
        for (let i = 0; i < this.missedFields.length; i++) {
         var key = this.missedFields[i]
          if (!key) return ''
          key = key.toString()
          key = key.split('-').join(' ')
          key = key.split('_').join(' ')
          req.push(' ' + key.charAt(0).toUpperCase() + key.slice(1))
        }
        let filedName = req.join()
        this.$notify({
          // title: 'Villa',
          customClass: 'error-msg',
          message: h('i', { style: 'color: #f7653a' }, 
          'Það verður að fylla út í alla reiti.')
        })
      }
    },
    isValidData () {
      let missedFields = []
      for (let fieldIndex in this.mandatoryFields) {
        if (this.medalInfo && this.medalInfo[this.mandatoryFields[fieldIndex]] && this.medalInfo[this.mandatoryFields[fieldIndex]] !== '') {
          continue
        } else {
          missedFields.push(this.mandatoryFields[fieldIndex])
        }
      }
      return missedFields
    }
  }
}
</script>

<style lang="scss" scoped>
.sub-text {
  &.thanks {
    font-size: 20px;
  }
}
.medal-page-wrap {
  // height: calc(100% - 119px);
  height: calc(100% - 66px);
  .game-outer, .game-outer > div {
    height: 100%;
  }
  .medal-details-wrap {
    display: flex;
    height: 100%;
    justify-content: center;
    align-items: center;
  }
}
.form-group {
  label {
    text-align: left;
  }
  input {
    padding: 1.3rem;
  }
  &.address {
    width: 75%
  }
  &.post-num {
    width: 25%;
    padding-left: 2rem;
  }
}
.button {
  padding: 1.3rem 11rem;
  border-radius: 10px;
}
.detail-block-outer {
  display: flex;
}
.medal-block {
  display: block;
}
.home-page {
  .medal-details {
    // padding-top: 3rem;
    position: relative;
    max-width: 650px;
    min-width: 550px;
    margin: 0 auto;
    text-align: center;
  }
}
.status-image {
  // svg {
    max-width: 130px;
    margin: 0 auto;
    height: 130px;
  // }
}
.row {
  margin-right: 0;
  margin-left: 0
}
.medal-basic-form {
  padding-top: 25px;
  position: relative;
  opacity: 0;
  animation-duration: 2s;
  animation-fill-mode: both;
  animation-name: medal-form-transition;
}
.facebook {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
  .no-thanx {
    background: #FFFFFF;
    border: 1px solid #FCBD00;
  }
}
@keyframes medal-form-transition {
  0% {
      opacity: 0;
      transform: translateY(20px);
  }
  100% {
    opacity: 1;
    transform: translateY(0px);
  }
}
@media (max-width: 768px) {
  .form-group {
    &.address {
      width: 70%
    }
    &.post-num {
      width: 30%;
      padding-left: 1.5rem;
    }
  }
  .status-image {
    max-width: 100px;
    height: 96px;
  }
  .medal-details-wrap {
    padding-top: 119px;
    .medal-details {
      padding-top: 9rem !important;
      min-width: initial;
    }
    .medal-details .medal-basic-form {
      max-width: 315px;
      margin: 0 auto;
      padding-left: 10px;
      padding-right: 10px;
    }
    .facebook {
      flex-direction: column;
      gap: 10px;
      .medal-send {
        margin-right: 0;
      }
      .no-thanx {
        margin-top: 0;
      }
    }
  }
  .medal-page-wrap {
    &.quiz-completed {
      height: 100%;
    }
    &.height-100 {
      height: 100%;
    }
  }
  .medal-details-wrap {
    padding-top: 0;
    .medal-details .medal-basic-form {
      max-width: 315px;
      margin: 0 auto;
    }
    .facebook .medal-send {
      margin-right: 0;
    }
  }
}

@media (max-width: 480px) {
  .medal-block {
    height: 165px;
  }
}
@media (max-width: 320px) {
  .form-group label {
    margin-left: 3px;
  }
  .form-group.post-num {
    width: 35%;
  }
  .form-group.address {
    width: 65%;
  }
  .medal-page-wrap {
    .medal-details-wrap {
      display: block;
      &.display-flex {
        display: flex;
      }
    }
  }
  .medal-details-wrap {
    .facebook {
      .medal-send {
        padding: 1.3rem 5.5rem;
      }
    }
  }
}
</style>